import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="border-y border-primary/40 bg-background py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-40" data-mp="12su1nsplz4ev">
      <div className="mx-auto max-w-4xl px-4" data-id="element-41" data-mp="xt92bh6j0u1m">
        <h2 id="closing-title" className="text-balance text-center text-4xl font-bold leading-[1.05] tracking-tight text-foreground sm:text-5xl" data-id="element-42" data-mp="xsfqi1spnecm">
          Stop Struggling. <span className="text-accent" data-id="element-43" data-mp="17sq4vpqhertd">Start Understanding.</span>
        </h2>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-44" data-mp="1lj3cts3di6ip">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-xl border-l-4 border-primary bg-surface px-4 py-3 text-sm font-semibold text-foreground shadow-glow" data-id="element-45" data-mp="1hhzzbc8ssmkn" data-mpi={index}>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-primary-strong" aria-hidden="true" data-id="element-46" data-mp="27djgarn006ab" />
              {line}
            </motion.li>)}
        </ul>
      </div>
    </section>;
}